import React, { FC, ReactNode } from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 48px - 35px)', // Adjust height based on header (48px) and bottom padding (35px)
  },
  header: {
    flex: '0 0 auto',
  },
}));

interface VirtualizedListWrapperProps {
  title: ReactNode;
  filters: ReactNode;
  children: ReactNode;
}

const VirtualizedListWrapper: FC<VirtualizedListWrapperProps> = ({ title, filters, children }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        {title}
        {filters}
      </div>
      {children}
    </div>
  );
};

export default VirtualizedListWrapper;
